export default __webpack_public_path__ + "static/media/7.25475b9a.jpg";